export const azureVmScaleSetPaths = {
  list: (connectionId) => `/compute/cloud-account-connections/${connectionId}/azure/vm-scale-sets`,
  create: (connectionId) => `/compute/cloud-account-connections/${connectionId}/azure/vm-scale-sets`,
  detail: (connectionId, resourceGroup, name) =>
    `/compute/cloud-account-connections/${connectionId}/azure/vm-scale-sets/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(name)}`,
  action: (connectionId, resourceGroup, name, action) =>
    `/compute/cloud-account-connections/${connectionId}/azure/vm-scale-sets/${encodeURIComponent(resourceGroup)}/${encodeURIComponent(name)}/${encodeURIComponent(action)}`,
};
